import moment from 'moment-timezone';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { paths } from '../../../routes';
import utils from '../../../services/utils';
import { setInvoicesToPay } from '../../../store/slices/Invoices';
import Button from '../../Buttons/Button/Button';
import DetailInvoiceFields from '../DetailInvoiceFields/DetailInvoiceFields';
import DetailPaymentHistory from '../DetailPaymentHistory/DetailPaymentHistory';
import useGet from '../../../services/hooks/http/useGet';
import apiMethods from '../../../apis';
import Context from '../../../store/context';
import { ReactComponent as PencilWrite } from '../../../assets/icons/PencilWrite.svg';

import classes from './InvoiceDetail.module.scss';
import ShowItems from '../ShowItems/ShowItems';
import CreateOrEditPurchase from '../../CreateOrEditPurchase/CreateOrEditPurchase';
import BackButton from '../../Buttons/BackButton/BackButton';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Tags from '../../Tags/Tags';
import { statusAccountLabel } from '../../../store/constants/statusDruoAccounts';

const InvoiceDetail = ({ refetch, invoice, supplier, isForPay, isEdit, isHistoryPayment }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [fetchVoucher, setFetchVoucher] = useState({ fetch: false, purchaseId: '', paymentId: '' });

  const {
    modal: { showError }
  } = useContext(Context);

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getPurchasePayoutVoucher, [fetchVoucher.purchaseId, fetchVoucher.paymentId], fetchVoucher.fetch);

  const [current, setCurrent] = useState({ view: 0, payment: {}, invoice: {} });

  useEffect(() => {
    if (getPayedVoucherSuccess) {
      setFetchVoucher({ fetch: false, purchaseId: '', paymentId: '' });
      utils.downloadFileByUrl(getPayedVoucher);
    } else if (getPayedVoucherError) {
      showError({ title: 'Descargar comprobante', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  const payInvoice = () => {
    dispatch(
      setInvoicesToPay({
        invoicesToPay: [
          {
            invoices: [
              { ...invoice, valueSelectionType: 'all', comments: '', payMethod: '', dateTime: moment().format('YYYY-MM-DD') }
            ],
            info: {
              businessName: invoice.supplier,
              supplierId: invoice.supplierId,
              status: false,
              supplierBankId: '',
              options: []
            }
          }
        ],
        typePay: 'payInvoice',
        route: paths.invoices
      })
    );
    navigate(paths.payout);
  };

  const showDetail = payment => {
    setCurrent({ view: 1, payment });
  };

  const backView = () => {
    setCurrent({ view: 0, payment: {} });
  };

  const downloadFile = () => {
    setFetchVoucher({ fetch: true, purchaseId: invoice.purchaseId, paymentId: current.payment.paymentId });
  };

  const editInvoice = () => {
    const invoiceToEdit = {
      ...invoice,
      items: !!invoice.items
        ? invoice.items.map(item => ({
            ...item,
            tax: item.taxes.length !== 0 ? item.taxes[0].taxId : '',
            taxableAmount: item.taxes.length !== 0 ? item.taxes[0].taxableAmount : 0,
            taxAmount: item.taxes.length !== 0 ? item.taxes[0].taxAmount : 0,
            percent: item.taxes.length !== 0 ? item.taxes[0].percent : 0,
            isShow: false
          }))
        : []
    };
    setCurrent({ view: 2, invoice: invoiceToEdit });
    //showModal();
  };

  return (
    <div>
      {}
      {current.view === 0 && (
        <>
          <span className='bold-18'>Detalles de cuenta de cobro</span>
          {isHistoryPayment && (
            <div className={classes.pay}>
              <span className='semibold-18'>Información del pago</span>
              <div className={classes.grid}>
                <FieldBold title='ESTADO DE PAGO'>
                  <Tags
                    text={statusAccountLabel[invoice.meloStatus]?.label || invoice.meloStatus || 'Sin estado'}
                    type={statusAccountLabel[invoice.meloStatus]?.color || 'gray'}
                  />
                </FieldBold>
                <FieldBold title='MONTO PAGADO' value={utils.moneyFormat(invoice.payedValue)} />
              </div>
            </div>
          )}
          <div>
            <DetailInvoiceFields
              invoice={invoice}
              supplier={supplier}
              showDetailPay={showDetail}
              isHistoryPayment={isHistoryPayment}
            />
          </div>
          <ShowItems className={classes.items} items={invoice.items} />
          {isEdit && (
            <Button onClick={editInvoice} className={classes.edit} Icon={PencilWrite} custom='quaternary'>
              Editar información
            </Button>
          )}
          {isForPay && (
            <div className={classes.button}>
              <Button onClick={payInvoice} color='purple'>
                Pagar cuenta
              </Button>
            </div>
          )}
        </>
      )}
      {current.view === 1 && <DetailPaymentHistory backView={backView} downloadFile={downloadFile} payment={current.payment} />}
      {current.view === 2 && (
        <div>
          <BackButton className={classes.back} onClick={backView} />
          <CreateOrEditPurchase
            refetch={refetch}
            isEdit={true}
            name={invoice.supplierName}
            purchasesData={current.invoice}
            supplierId={invoice.supplierId}
          />
        </div>
      )}
    </div>
  );
};

export default InvoiceDetail;
